// @flow
import * as React from 'react';
import idx from 'idx';
import { graphql } from 'react-apollo';

import GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG from './queries/AdminAutoMessageSftpCredentialsQuery.gql';
import type { AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials } from './queries/__generated__/AdminAutoMessageSftpCredentials';

type Props = {
  children: (props: {
    loading: ?boolean,
    autoMessageSftpCredentials: ?(AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials[]),
    refetch: ?() => void,
  }) => React.Node,
  data: ReactApolloData<*>,
  viewingOrgUuid: string,
};

class AdminAutoMessageSftpCredentialsContainer extends React.Component<Props, void> {
  render() {
    const { data, children } = this.props;

    return children({
      refetch: idx(data, _ => _.refetch),
      loading: idx(data, _ => _.loading),
      autoMessageSftpCredentials: idx(data, _ => _.autoMessaging.sftpCredentials),
    });
  }
}

const withAutoMessageSftpCredentials = graphql(GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG, {
  options: ({ viewingOrgUuid }) => ({
    variables: { orgUuid: viewingOrgUuid },
  }),
});

export { AdminAutoMessageSftpCredentialsContainer };

export default withAutoMessageSftpCredentials(AdminAutoMessageSftpCredentialsContainer);
